import { render, staticRenderFns } from "./SDSEditor.vue?vue&type=template&id=1c378244&scoped=true"
import script from "./SDSEditor.vue?vue&type=script&lang=js"
export * from "./SDSEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c378244",
  null
  
)

export default component.exports